export const MuiInputAdornment = {
  styleOverrides: {
    root: {
      '.MuiButtonBase-root:hover svg': {
        color: 'rgba(34, 40, 34, 1)',
      },

      '.MuiSvgIcon-root': {
        color: 'rgba(159, 159, 159, 1)',
      },
    },
  },
};
